import { useSelector } from 'react-redux';

// material-ui
import { Box, Typography } from '@mui/material';

// project import
import NavGroup from './NavGroup';
import ChromeOutlined from '@ant-design/icons/ChromeOutlined';
import useMain from 'hooks/useMain';
import { dispatch } from 'store';
import { setState } from 'store/reducers/menu';
import { useEffect, useMemo } from 'react';
import { mapsMenu } from 'menu-items/maps';
import { removeProject } from 'store/reducers/authentication';
import DashboardOutlined from '@mui/icons-material/DashboardOutlined';
import ViewModuleOutlined from '@mui/icons-material/ViewModuleOutlined';
import SensorWindowOutlined from '@mui/icons-material/SensorWindowOutlined';
import DoorFrontOutlined from '@mui/icons-material/DoorFrontOutlined';
import CategoryOutlined from '@mui/icons-material/CategoryOutlined';
import AutoAwesomeMosaicOutlined from '@mui/icons-material/AutoAwesomeMosaicOutlined';
import BusinessOutlined from '@mui/icons-material/BusinessOutlined';
import HdrStrongOutlined from '@mui/icons-material/HdrStrongOutlined';
import SummarizeOutlined from '@mui/icons-material/SummarizeOutlined';
import ReportGmailerrorredOutlined from '@mui/icons-material/ReportGmailerrorredOutlined';
import PhoneAndroidOutlined from '@mui/icons-material/PhoneAndroidOutlined';
// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const returnMenuIcon = (path) => {
  switch (path) {
    case 'dashboard':
      return DashboardOutlined;
    case 'appDeviceVersion':
      return PhoneAndroidOutlined;
    case 'mic':
      return ViewModuleOutlined;
    case 'alw':
      return SensorWindowOutlined;
    case 'tid':
      return DoorFrontOutlined;
    case 'sta':
      return DoorFrontOutlined;
    case 'meg':
      return DoorFrontOutlined;
    case 'category':
      return CategoryOutlined;
    case 'subcategory':
      return AutoAwesomeMosaicOutlined;
    case 'company':
      return BusinessOutlined;
    case 'concreteGrade':
      return HdrStrongOutlined;
    case 'summary':
      return SummarizeOutlined;
    case 'dataAccuracyAlert':
      return ReportGmailerrorredOutlined;

    default:
      return DashboardOutlined;
  }
};

const Navigation = () => {
  const menu = useSelector((state) => state.menu);
  const { upperCaseLang, useLocation } = useMain();
  const { drawerOpen, leftMenuList } = menu;
  const location = useLocation();
  const leftMenu = useSelector((state) => state.menu.formattedLeftMenu);

  const leftMenuListModified = useMemo(
    () =>
      leftMenuList
        ?.map(({ Page, Components, ...rest }) => ({
          id: Page,
          type: 'group',
          url: `/${Page.toLowerCase()}`,
          title: rest[`Page${upperCaseLang}`],
          children: Components?.map(({ ComponentPath, ...rest }) => ({
            id: rest[`ComponentNameEN`],
            icon: returnMenuIcon(ComponentPath),
            type: 'item',
            title: rest[`ComponentName${upperCaseLang}`],
            url: Page === 'Home' || Page === 'UserAdmin' ? `/${ComponentPath}` : `/${Page?.toLowerCase() || ''}/${ComponentPath}`,
            breadcrumbs: Page !== 'Functions'
          })),
          ...rest
        }))
        ?.sort((a, b) => a?.Sort - b?.Sort) || [],
    [leftMenuList, upperCaseLang]
  );

  useEffect(() => {
    // if (location.pathname.match(/map/i)) {
    //   dispatch(setState(['formattedLeftMenu', [mapsMenu]]));
    // } else {
    dispatch(setState(['formattedLeftMenu', leftMenuListModified]));
    // }
  }, [leftMenuListModified, location?.pathname]);

  useEffect(() => {
    // Keep Admin product context; only clear project on admin-style pages
    if (location.pathname.match(/\/userAdmin/i) || location.pathname.match(/\/appadmin/i)) {
      dispatch(removeProject());
    }
  }, [location?.pathname]);

  const navGroups =
    leftMenu?.map((item) => {
      switch (item.type) {
        case 'group':
          return <NavGroup key={item.id} item={item} />;

        default:
          return (
            <Typography key={item.id} variant="h6" color="error" align="center">
              Fix - Navigation Group
            </Typography>
          );
      }
    }) || [];

  return <Box sx={{ pt: drawerOpen ? 2 : 0, '& > ul:first-of-type': { mt: 0 } }}>{navGroups}</Box>;
};

export default Navigation;
